import React from 'react';
import PropTypes from 'prop-types';

import { TextButton } from '@zillow/constellation';

const propTypes = {
    onAdClick: PropTypes.func.isRequired,
    insertionOrderId: PropTypes.number.isRequired,
};

class BoostAdPreviewLink extends React.Component {
    constructor(props) {
        super(props);
        this.handleLinkClick = this.handleLinkClick.bind(this);
    }

    handleLinkClick(e) {
        e.preventDefault();
        this.props.onAdClick(this.props.insertionOrderId);
    }

    render() {
        return (
            <TextButton fontType="bodySmallHeading" onClick={this.handleLinkClick}>
                View ad
            </TextButton>
        );
    }
}

BoostAdPreviewLink.propTypes = propTypes;

export default BoostAdPreviewLink;
